import { Output, EventEmitter, Component } from "@angular/core";
import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { ReportsService, NursingStation, DiscontinuedControlledMedicationOptions, DeaClass, ApiRequestDto, ApiRequestDtoDiscontinuedControlledMedicationOptions } from "../../api";
import { FacilitiesService } from "../../core";
import PatientStatusEnum = DiscontinuedControlledMedicationOptions.PatientStatusEnum;
import { DateConversion } from "../../shared/date/date-range";
import { LoadingError, ErrorObjectTypeEnum } from "../../core/error-catching.service";
import { catchError } from "rxjs/operators";

export const DEA_CLASSES: DeaClass[] = [
    {
        Name: "C-II",
        IsSelected: true
    },
    {
        Name: "C-III",
        IsSelected: true
    }, 
    {
        Name: "C-IV",
        IsSelected: true
    },
    {
        Name: "C-V",
        IsSelected: true
    }
];

enum WizardPage {
    Options = 1,
    NursingStations = 2,
}

@Component({
    selector: 'my-discontinued-controlled-medications-modal',
    templateUrl: 'discontinued-controlled-medications-modal.component.html',
    styleUrls: ['discontinued-controlled-medications-modal.component.scss']
})
export class DiscontinuedControlledMedicationsModal extends DownloadFileContentModal {

    reportName: string = "Discontinued Controlled Medications";
    title: string = "Download Discontinued Controlled Medications";
    selectedPage: number = WizardPage.Options;
    MyWizardPage = WizardPage;
    hideSpinner:boolean = true;

    patientStatuses: PatientStatusEnum[];
    selectedPatientStatus: PatientStatusEnum;

    deaClasses: DeaClass[] = [];
    areAllDeaClassesSelected: boolean = false;
    hasSelectedDeaClasses: boolean = false;

    allNursingStations: NursingStation[] = [];

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
        
        this.patientStatuses = [PatientStatusEnum.Active, PatientStatusEnum.Inactive, PatientStatusEnum.Both]
        this.deaClasses = DEA_CLASSES.slice();
        this.maxDate = this.endDate;
    }

    show() {
        this.selectedPage = WizardPage.Options;
        this.selectAllDeaClasses();
        this.selectedPatientStatus = PatientStatusEnum.Active;
        super.show();
    }

    selectedPatientStatusChange(newValue) {
        this.selectedPatientStatus = newValue;
    }

    selectDeaClass(){
        setTimeout(()=>{
            let selectedDeaClassCount = this.deaClasses.filter(x => x.IsSelected).length;

            if(this.areAllDeaClassesSelected && selectedDeaClassCount === this.deaClasses.length - 1){
                this.deaClasses.forEach(f => f.IsSelected = !f.IsSelected);
                this.areAllDeaClassesSelected = false;
            }else{
                this.hasSelectedDeaClasses =  selectedDeaClassCount > 0;
                this.areAllDeaClassesSelected = this.deaClasses.length === selectedDeaClassCount;
            }
        });
    }

    selectAllDeaClasses() {
        this.deaClasses.forEach(ns => ns.IsSelected=true);
        this.selectDeaClass();
    }

    canShowNursingStationsPage() : boolean {
        if (!this.isValidDateRange) {
            return false;
        }
        else if (!this.hasSelectedDeaClasses) {
            return false;
        }
        else {
            return true;
        }
    }

    showNursingStationsPage() {
        this.hideSpinner = false;
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.reportService.reportsGetNursingStations(requestParams).subscribe((result) => {
            this.allNursingStations = result;
            this.hideSpinner = true;
            this.selectedPage = WizardPage.NursingStations;
        });
    }

    canGenerateReport() : boolean {
        let selectedNursingStations = this.allNursingStations.filter(ns => ns.IsSelected).slice();
        let result = this.hideSpinner && selectedNursingStations.length > 0;
        return result;
    }

    generateContent() {
        this.hideSpinner = false;
        let selectedDeaClasses = this.deaClasses.filter(deaClass => deaClass.IsSelected).slice();
        let selectedNursingStations = this.allNursingStations.filter(ns => ns.IsSelected).slice();

        let options: DiscontinuedControlledMedicationOptions = {
            StartDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.startDate),
            EndDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.endDate),
            PatientStatus: this.selectedPatientStatus,
            DeaClasses: selectedDeaClasses,
            NursingStations: selectedNursingStations
        };

        const requestParams: ApiRequestDtoDiscontinuedControlledMedicationOptions = { 
            OrgList: this.facilityService.selectedAsOrgList,
            _RequestOptions: options
        };
        this.reportService.reportsGetDiscontinuedControlledMedicationsReport(requestParams)
            .pipe(catchError((error) => {
                this.hideSpinner = true;
                throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
            }))
            .subscribe((result: Blob) => {
                this.downloadFile(result, "DiscontinuedControlledMedications.xls");
                this.closeModal();
            });
    }

    back() {
        if (this.selectedPage > WizardPage.Options) {
            this.selectedPage--;
        }
    }
}